import { render, staticRenderFns } from "./DeliveryType.vue?vue&type=template&id=283249ca"
import script from "./DeliveryType.vue?vue&type=script&lang=ts"
export * from "./DeliveryType.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryType.vue?vue&type=style&index=0&id=283249ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports